import React, {useState, useEffect} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import DataLayerPush from 'utils/gtm';

import AdvancedSearchInputV1 from 'modules/advanced-search/AdvancedSearchInputV1';
import AdvancedSearchInputV2 from 'modules/advanced-search/AdvancedSearchInputV2';
import {
  InputGroup,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  ButtonDropdown,
} from 'reactstrap';
import {CaptchaModal} from 'components/Captcha';
import {queryStringify} from 'utils/http';
import {useAuth} from 'contexts/AuthContext';
import {isEmpty} from 'lodash';
import {SearchSelectCE} from 'components/Forms/Searches';
import {SearchSelectCert} from 'components/Forms/Searches';
import cx from 'classnames';
import styles from './styles.module.scss';
import {useMembership} from 'contexts/MembershipContext';
import MuiIcon from 'components/Icons/MuiIcon';

function PrivateNavSearch(props) {
  const {isMobile, hasSidebar} = props;

  const history = useHistory();
  const location = useLocation();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchType, setSearchType] = useState('certified-entity');
  const [label, setLabel] = useState('Company Name');
  const {isLegacyUser} = useMembership();

  const {isDCAccount} = useAuth();
  const {eventSearchInput, eventSearchClick} = DataLayerPush;

  useEffect(() => {
    if (!isMobile) {
      setDropdownOpen(false);
    }
  }, [isMobile]);

  function toggleDropdown() {
    setDropdownOpen(!dropdownOpen);
  }

  function onSelectChange(event, trigger = true, label) {
    setDropdownOpen(!dropdownOpen && trigger);
    setSearchType(event.target.value);
    setLabel(label);
  }

  function onSubmit(data) {
    history.push({pathname: '/advanced-search', search: queryStringify(data)});
  }

  const isCE = searchType === 'certified-entity';
  const {pathname} = location;

  return (
    <CaptchaModal initialCheck={false}>
      {({verifyCaptcha}) => {
        if (!isDCAccount) {
          const props = {
            header: true,
            name: 'search',
            verifyCaptcha,
            onSubmit,
          };
          return (
            <div className="ml-3 mr-2">
              {isLegacyUser ? (
                <AdvancedSearchInputV1 {...props} />
              ) : (
                <AdvancedSearchInputV2 {...props} />
              )}
            </div>
          );
        }

        return (
          <div
            className={cx(styles['search__forms'], {
              'mx-0': hasSidebar && !isMobile,
            })}
          >
            <InputGroup
              className={cx(
                'onboard-search-verify',
                styles['private-search__input-group']
              )}
            >
              {!isMobile && (
                <ButtonDropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                  <DropdownToggle
                    className={styles['private-search__dropdown']}
                  >
                    <MuiIcon
                      className="text-primary mr-1"
                      name={isCE ? 'assured_workload' : 'fact_check'}
                    />
                    <span className="d-sm-none d-xl-inline-block">{label}</span>
                    <MuiIcon className="ml-1" name="expand_more" />
                  </DropdownToggle>
                  <DropdownMenu className="mt-2 py-0" container="">
                    <DropdownItem
                      className={styles['private-search__dropdown--item']}
                      value="certified-entity"
                      onClick={(event) =>
                        onSelectChange(
                          event,
                          'certified-entity',
                          'Company Name'
                        )
                      }
                    >
                      <MuiIcon
                        name="assured_workload"
                        className="mr-2 text-primary"
                      />
                      Company Name
                    </DropdownItem>
                    <DropdownItem
                      className={styles['private-search__dropdown--item']}
                      value="certification"
                      onClick={(event) =>
                        onSelectChange(
                          event,
                          'certification',
                          'Certification ID'
                        )
                      }
                    >
                      <MuiIcon
                        name="fact_check"
                        className="mr-2 text-primary"
                      />
                      Certification ID
                    </DropdownItem>
                  </DropdownMenu>
                </ButtonDropdown>
              )}

              <div className="flex-grow-1" onClick={verifyCaptcha}>
                {searchType === 'certified-entity' ? (
                  <SearchSelectCE
                    key={pathname}
                    dropdownOpen={dropdownOpen}
                    verifyCaptcha={verifyCaptcha}
                    onChangeType={onSelectChange}
                    className={styles['form-control-search']}
                    onInputChange={(input, result) => {
                      eventSearchInput({
                        searchInputEntityType: 'ce',
                        searchInputLocation: 'header',
                        searchInputKeyword: input,
                        searchInputResult: !isEmpty(result),
                      });
                    }}
                    onSelect={(selected, keyword) => {
                      const {company_id, company_name} = selected || {};

                      if (!isEmpty(selected)) {
                        eventSearchClick({
                          searchClickEntityType: 'ce',
                          searchClickLocation: 'header',
                          searchClickKeyword: keyword,
                          searchClickEntityName: company_name,
                          searchClickEntityId: company_id,
                        });
                      }
                    }}
                  />
                ) : (
                  <SearchSelectCert
                    key={pathname}
                    dropdownOpen={dropdownOpen}
                    verifyCaptcha={verifyCaptcha}
                    onChangeType={onSelectChange}
                    className={styles['form-control-search']}
                    onInputChange={(input, result) => {
                      eventSearchInput({
                        searchInputEntityType: 'cert',
                        searchInputLocation: 'header',
                        searchInputKeyword: input,
                        searchInputResult: !isEmpty(result),
                      });
                    }}
                    onSelect={(selected, keyword) => {
                      const {company_certifications_id, company_name} =
                        selected || {};

                      if (!isEmpty(selected)) {
                        eventSearchClick({
                          searchClickEntityType: 'cert',
                          searchClickLocation: 'header',
                          searchClickKeyword: keyword,
                          searchClickEntityName: company_name,
                          searchClickEntityId: company_certifications_id,
                        });
                      }
                    }}
                  />
                )}
              </div>
            </InputGroup>
          </div>
        );
      }}
    </CaptchaModal>
  );
}

export default PrivateNavSearch;
